// =============================================================================
// GENERATED by scripts/build-shared.cjs from functions/src/shared/crewSkills.js
// DO NOT EDIT — edit the canonical file and re-run `node scripts/build-shared.cjs`.
// (TASK-9844: ONE crew-skills rule — Roster skills, the dispatch crew-picker
// warning and the connector's crew tools.)
//
// Side-effect module: attaches `window.CrewSkills`. Views read it at CALL time.
//
// The body below is the canonical file's PORTABLE CORE, copied byte for byte.
// =============================================================================
(function () {
  'use strict';

  var CS_LABEL_MAX = 40;
  var CS_LIST_MAX = 60;
  var CS_REQUIRED_MAX = 12;
  var CS_TYPE_KEYS_MAX = 120;

  function csStr(v) { return v == null ? '' : String(v); }

  /** Clean a skill name for storage: collapse whitespace, trim, cap. */
  function csCleanLabel(raw) {
    return csStr(raw).replace(/[\u0000-\u001f\u007f<>]/g, '').replace(/\s+/g, ' ').trim().slice(0, CS_LABEL_MAX);
  }

  /** A YYYY-MM-DD that is a real calendar day, or ''. */
  function csDateKey(v) {
    var s = csStr(v).trim().slice(0, 10);
    if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return '';
    var t = Date.parse(s + 'T00:00:00Z');
    if (isNaN(t)) return '';
    return new Date(t).toISOString().slice(0, 10) === s ? s : '';
  }

  function csIdOk(id) { return /^sk_[a-z0-9_]{1,48}$/.test(csStr(id)); }

  /** TASK-9911 M3 — a certification requirement id: 'cert:<safetyTrainings itemId>'. */
  function csCertIdOk(id) { return /^cert:[A-Za-z0-9_-]{1,64}$/.test(csStr(id)); }
  /** 'cert:<itemId>' for a training itemId, or '' when the itemId can't be one. */
  function csCertId(itemId) { var s = 'cert:' + csStr(itemId); return csCertIdOk(s) ? s : ''; }
  /** The training itemId inside a cert requirement id, or ''. */
  function csCertItemId(id) { return csCertIdOk(id) ? csStr(id).slice(5) : ''; }

  /** A new stable id from a label, unique against `taken` (array of ids). Generated ONCE. */
  function csMakeId(label, taken) {
    var base = 'sk_' + (csCleanLabel(label).toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '').slice(0, 40) || 'skill');
    var used = {};
    (Array.isArray(taken) ? taken : []).forEach(function (t) { used[t] = true; });
    if (!used[base]) return base;
    for (var n = 2; n < 1000; n++) { if (!used[base + '_' + n]) return base + '_' + n; }
    return base + '_' + Date.now();
  }

  function csIdList(raw, known) {
    var out = [];
    if (!Array.isArray(raw)) return out;
    for (var i = 0; i < raw.length && out.length < CS_REQUIRED_MAX; i++) {
      var id = csStr(raw[i]);
      // M3 — a cert id is kept as stored (the training list lives in HR); the
      // check drops one whose training is gone or archived.
      if ((!known[id] && !csCertIdOk(id)) || out.indexOf(id) >= 0) continue;
      out.push(id);
    }
    return out;
  }

  function csTypeMap(raw, known) {
    var out = {};
    if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return out;
    var keys = Object.keys(raw).slice(0, CS_TYPE_KEYS_MAX);
    for (var i = 0; i < keys.length; i++) {
      var k = csStr(keys[i]);
      if (!k || k.length > 80) continue;
      var ids = csIdList(raw[k], known);
      if (ids.length) out[k] = ids;
    }
    return out;
  }

  /**
   * The company's config, sanitised. Never throws. Accepts the tenant SETTINGS
   * map (reads settings.crewSkills) or the crewSkills map itself.
   */
  function csConfig(settingsOrConfig) {
    var s = settingsOrConfig && typeof settingsOrConfig === 'object' ? settingsOrConfig : {};
    var raw = (s.crewSkills && typeof s.crewSkills === 'object') ? s.crewSkills : (Array.isArray(s.list) || 'enabled' in s ? s : {});
    var list = [];
    var known = {};
    var src = Array.isArray(raw.list) ? raw.list : [];
    for (var i = 0; i < src.length && list.length < CS_LIST_MAX; i++) {
      var r = src[i];
      if (!r || typeof r !== 'object') continue;
      var id = csStr(r.id);
      var label = csCleanLabel(r.label);
      if (!csIdOk(id) || !label || known[id]) continue;
      known[id] = true;
      list.push({ id: id, label: label, archived: r.archived === true });
    }
    return {
      enabled: raw.enabled === true,
      list: list,
      byJobType: csTypeMap(raw.byJobType, known),
      byVehicleType: csTypeMap(raw.byVehicleType, known),
    };
  }

  /**
   * TASK-9911 — true when the company keeps at least one active skill. This
   * alone lets people carry skills; it does NOT depend on the warn switch.
   */
  function csHasSkills(config) {
    var c = config && Array.isArray(config.list) ? config : csConfig(config);
    for (var i = 0; i < c.list.length; i++) if (!c.list[i].archived) return true;
    return false;
  }

  /**
   * The WARN switch: "Warn dispatch when someone is missing a skill" is on AND
   * there is at least one active skill. Gates dispatch warnings and job/vehicle-
   * type requirements only (TASK-9911 split).
   */
  function csIsOn(config) {
    var c = config && Array.isArray(config.list) ? config : csConfig(config);
    if (!c.enabled) return false;
    for (var i = 0; i < c.list.length; i++) if (!c.list[i].archived) return true;
    return csHasCertRequirement(c);
  }

  /** TASK-9911 M3 — true when any job type or vehicle type needs a certification. */
  function csHasCertRequirement(config) {
    var c = config && Array.isArray(config.list) ? config : csConfig(config);
    var maps = [c.byJobType || {}, c.byVehicleType || {}];
    for (var m = 0; m < maps.length; m++) {
      var keys = Object.keys(maps[m]);
      for (var k = 0; k < keys.length; k++) {
        var ids = maps[m][keys[k]] || [];
        for (var i = 0; i < ids.length; i++) if (csCertIdOk(ids[i])) return true;
      }
    }
    return false;
  }

  /**
   * TASK-9911 M3 — the active trainings a requirement can name, from
   * settings.safetyTrainings (or that array): [{ id: 'cert:<itemId>', itemId,
   * label }]. Archived and malformed rows dropped; label capped like a skill.
   */
  function csCertList(safetyTrainings) {
    var src = Array.isArray(safetyTrainings) ? safetyTrainings
      : (safetyTrainings && Array.isArray(safetyTrainings.safetyTrainings) ? safetyTrainings.safetyTrainings : []);
    var out = [];
    var seen = {};
    for (var i = 0; i < src.length && out.length < CS_LIST_MAX; i++) {
      var r = src[i];
      if (!r || typeof r !== 'object' || r.archived === true) continue;
      var id = csCertId(r.itemId);
      var label = csCleanLabel(r.label);
      if (!id || !label || seen[id]) continue;
      seen[id] = true;
      out.push({ id: id, itemId: csStr(r.itemId), label: label });
    }
    return out;
  }

  function csSkillById(config, id) {
    var c = config && Array.isArray(config.list) ? config : csConfig(config);
    for (var i = 0; i < c.list.length; i++) if (c.list[i].id === id) return c.list[i];
    return null;
  }

  /** A person's skills, sanitised: [{ id, expiresOn|null }], de-duplicated. */
  function csPersonSkills(person) {
    var raw = person && Array.isArray(person.skills) ? person.skills : [];
    var out = [];
    var seen = {};
    for (var i = 0; i < raw.length && out.length < CS_LIST_MAX; i++) {
      var r = raw[i];
      var id = typeof r === 'string' ? r : (r && typeof r === 'object' ? csStr(r.id) : '');
      if (!csIdOk(id) || seen[id]) continue;
      seen[id] = true;
      var exp = r && typeof r === 'object' ? csDateKey(r.expiresOn) : '';
      out.push({ id: id, expiresOn: exp || null });
    }
    return out;
  }

  /** Clean a person's skills for a SAVE: only ids the company list knows (archived kept). */
  function csCleanPersonSkills(raw, config) {
    var c = config && Array.isArray(config.list) ? config : csConfig(config);
    return csPersonSkills({ skills: raw }).filter(function (s) { return !!csSkillById(c, s.id); });
  }

  /** 'ok' | 'expired' | 'missing' — does this person hold `skillId` on `asOfKey`? */
  function csHolds(person, skillId, asOfKey) {
    var mine = csPersonSkills(person);
    var day = csDateKey(asOfKey);
    for (var i = 0; i < mine.length; i++) {
      if (mine[i].id !== skillId) continue;
      if (mine[i].expiresOn && day && mine[i].expiresOn < day) return 'expired';
      return 'ok';
    }
    return 'missing';
  }

  /** True when the person holds every id in `ids` (not expired on asOfKey). */
  function csQualified(person, ids, asOfKey) {
    var list = Array.isArray(ids) ? ids : [];
    for (var i = 0; i < list.length; i++) if (csHolds(person, list[i], asOfKey) !== 'ok') return false;
    return true;
  }

  /**
   * What the day needs. jobType = the job's type slug; vehicles = [{ type, label }]
   * (label = how the caller names that unit or type, e.g. "Vac Truck 12").
   * Returns [{ id, label, everyone: bool, neededFor: [text] }] — active skills only,
   * company list order. Empty when the feature is off.
   */
  function csRequired(config, jobType, jobTypeLabel, vehicles, certs) {
    var c = config && Array.isArray(config.list) ? config : csConfig(config);
    if (!csIsOn(c)) return [];
    // M3 — certs: csCertList(...) output. Absent = cert requirements skipped.
    var certList = Array.isArray(certs) ? certs : [];
    var certById = {};
    for (var ci = 0; ci < certList.length; ci++) if (certList[ci] && csCertIdOk(certList[ci].id)) certById[certList[ci].id] = certList[ci];
    var need = {};
    var add = function (id, everyone, why) {
      var isCert = csCertIdOk(id);
      var sk = isCert ? certById[id] : csSkillById(c, id);
      if (!sk || sk.archived) return;
      if (!need[id]) need[id] = { id: id, label: sk.label, everyone: false, neededFor: [] };
      if (isCert) { need[id].cert = true; need[id].itemId = csCertItemId(id); }
      if (everyone) need[id].everyone = true;
      if (why && need[id].neededFor.indexOf(why) < 0) need[id].neededFor.push(why);
    };
    var jt = csStr(jobType).trim() || 'job';
    var jobIds = c.byJobType[jt] || [];
    var jtWhy = csCleanLabel(jobTypeLabel) ? 'job type ' + csCleanLabel(jobTypeLabel) : 'this job type';
    for (var i = 0; i < jobIds.length; i++) add(jobIds[i], true, jtWhy);
    var vs = Array.isArray(vehicles) ? vehicles : [];
    for (var v = 0; v < vs.length; v++) {
      var t = vs[v] && csStr(vs[v].type);
      if (!t) continue;
      var ids = c.byVehicleType[t] || [];
      for (var j = 0; j < ids.length; j++) add(ids[j], false, csCleanLabel(vs[v].label) || t);
    }
    var out = [];
    for (var k = 0; k < c.list.length; k++) if (need[c.list[k].id]) out.push(need[c.list[k].id]);
    for (var q = 0; q < certList.length; q++) if (certList[q] && need[certList[q].id]) out.push(need[certList[q].id]);
    return out;
  }

  /**
   * TASK-9911 M3 — does this person hold a cert on asOfKey? `st` is HR's state
   * for the person + training ({ state, date }). Returns 'ok' | 'expired' |
   * 'missing' | 'na' | 'exempt'. Valid / expiring / on file (no expiry) hold; a
   * dated cert is judged against the day itself (a card that runs out before the
   * job day is expired that day). Missing, 'na' and 'exempt' never hold (row
   * spec); the warning names which, so noise reads apart from a real gap.
   */
  function csCertHolds(st, asOfKey) {
    var s = st && typeof st === 'object' ? csStr(st.state) : '';
    var date = st && typeof st === 'object' ? csDateKey(st.date) : '';
    var day = csDateKey(asOfKey);
    if (s === 'valid' || s === 'expiring' || s === 'noexpiry' || s === 'expired') {
      if (date && day) return date < day ? 'expired' : 'ok';
      return s === 'expired' ? 'expired' : 'ok';
    }
    if (s === 'na' || s === 'exempt') return s;
    return 'missing';
  }

  /**
   * TASK-9911 M3b — judged on a past/future day, only cards issued on or before
   * that day count. Returns { person, later } where `person` is a shallow copy
   * whose isnetTrainings for `itemId` drop cards issued after `dayKey` (so HR's
   * own newest-card rule picks the newest card issued on/before the day), and
   * `later` = true when at least one card was dropped. Undated cards are kept.
   */
  function csPersonAsOf(person, itemId, dayKey) {
    var day = csDateKey(dayKey);
    var cards = person && Array.isArray(person.isnetTrainings) ? person.isnetTrainings : null;
    if (!day || !cards) return { person: person, later: false };
    var later = false;
    var kept = cards.filter(function (t) {
      if (!t || csStr(t.requiredTrainingId) !== csStr(itemId)) return true;
      var iss = csDateKey(t.issueDate);
      if (iss && iss > day) { later = true; return false; }
      return true;
    });
    if (!later) return { person: person, later: false };
    var copy = {};
    for (var k in person) if (Object.prototype.hasOwnProperty.call(person, k)) copy[k] = person[k];
    copy.isnetTrainings = kept;
    return { person: copy, later: true };
  }

  /**
   * The crew check. drivers / helpers = person docs (each with at least `name`
   * and `skills`). Returns one issue per skill someone lacks:
   *   [{ id, label, neededFor: [text], missing: [name], expired: [{ name, expiresOn }] }]
   * Empty when the feature is off or nobody is short.
   */
  function csCheckCrew(input) {
    var o = input || {};
    var req = csRequired(o.config, o.jobType, o.jobTypeLabel, o.vehicles, o.certs);
    if (!req.length) return [];
    var certState = typeof o.certState === 'function' ? o.certState : null;
    var drivers = Array.isArray(o.drivers) ? o.drivers.filter(Boolean) : [];
    var helpers = Array.isArray(o.helpers) ? o.helpers.filter(Boolean) : [];
    var asOf = csDateKey(o.asOf);
    var nameOf = function (p) { return csStr(p.name).trim() || 'Unnamed person'; };
    var out = [];
    for (var i = 0; i < req.length; i++) {
      var r = req[i];
      var who = r.everyone ? drivers.concat(helpers.filter(function (h) { return drivers.indexOf(h) < 0; })) : drivers;
      var missing = [];
      var expired = [];
      var seen = {};
      // M3 — a cert needed but no way to read HR's state: say so, never pass it.
      if (r.cert && !certState) {
        if (who.length) out.push({ id: r.id, label: r.label, cert: true, unchecked: true, neededFor: r.neededFor.slice(), missing: [], expired: [] });
        continue;
      }
      for (var w = 0; w < who.length; w++) {
        var p = who[w];
        var key = csStr(p.id) || nameOf(p);
        if (seen[key]) continue;
        seen[key] = true;
        if (r.cert) {
          var cst = null;
          var pa = csPersonAsOf(p, r.itemId, asOf);
          try { cst = certState(pa.person, r.itemId); } catch (e) { cst = null; }
          var ch = csCertHolds(cst, asOf);
          if (ch === 'missing') missing.push(nameOf(p) + (pa.later ? ' (card issued after ' + asOf + ')' : ''));
          else if (ch === 'na') missing.push(nameOf(p) + ' (HR: not required for their role)');
          else if (ch === 'exempt') missing.push(nameOf(p) + ' (HR-exempt)');
          else if (ch === 'expired') expired.push({ name: nameOf(p), expiresOn: csDateKey(cst && cst.date) || null });
          continue;
        }
        var st = csHolds(p, r.id, asOf);
        if (st === 'missing') missing.push(nameOf(p));
        else if (st === 'expired') {
          var mine = csPersonSkills(p).filter(function (s) { return s.id === r.id; })[0];
          expired.push({ name: nameOf(p), expiresOn: mine ? mine.expiresOn : null });
        }
      }
      if (missing.length || expired.length) {
        var issue = { id: r.id, label: r.label, neededFor: r.neededFor.slice(), missing: missing, expired: expired };
        if (r.cert) issue.cert = true;
        out.push(issue);
      }
    }
    return out;
  }

  function csJoinNames(arr) {
    var a = Array.isArray(arr) ? arr : [];
    if (a.length <= 1) return a.join('');
    if (a.length === 2) return a[0] + ' and ' + a[1];
    if (a.length <= 4) return a.slice(0, -1).join(', ') + ' and ' + a[a.length - 1];
    return a.slice(0, 3).join(', ') + ' and ' + (a.length - 3) + ' more';
  }

  /** One plain-text line for an issue (callers escape it at the sink). */
  function csIssueText(issue) {
    var i = issue || {};
    var parts = [];
    if (i.missing && i.missing.length) parts.push(csJoinNames(i.missing) + (i.missing.length === 1 ? ' does not have it' : ' do not have it'));
    if (i.expired && i.expired.length) {
      parts.push(csJoinNames(i.expired.map(function (e) { return e.name + (e.expiresOn ? ' (expired ' + e.expiresOn + ')' : ''); })) + (i.expired.length === 1 ? ' has it expired' : ' have it expired'));
    }
    var why = i.neededFor && i.neededFor.length ? ' (needed for ' + csJoinNames(i.neededFor) + ')' : '';
    if (i.unchecked) return 'Could not check certification: ' + csStr(i.label) + why + ' — check the cards in HR before dispatching.';
    return (i.cert ? 'Missing certification: ' : 'Missing skill: ') + csStr(i.label) + why + ' — ' + parts.join('; ') + '.';
  }

  /** Skills that run out within `days` of todayKey (expired ones included), soonest first. For reminders. */
  function csExpiring(people, config, todayKey, days) {
    var c = config && Array.isArray(config.list) ? config : csConfig(config);
    var t = csDateKey(todayKey);
    if (!t || !csHasSkills(c)) return [];
    var win = typeof days === 'number' && days >= 0 ? days : 30;
    var today = Date.parse(t + 'T00:00:00Z');
    var out = [];
    (Array.isArray(people) ? people : []).forEach(function (p) {
      if (!p) return;
      csPersonSkills(p).forEach(function (s) {
        var sk = csSkillById(c, s.id);
        if (!sk || sk.archived || !s.expiresOn) return;
        var dl = Math.round((Date.parse(s.expiresOn + 'T00:00:00Z') - today) / 864e5);
        if (dl <= win) out.push({ personId: csStr(p.id) || null, name: csStr(p.name), skillId: s.id, label: sk.label, expiresOn: s.expiresOn, daysLeft: dl });
      });
    });
    out.sort(function (a, b) { return a.daysLeft - b.daysLeft; });
    return out;
  }

  /**
   * TASK-9911 — PURE. One skill on or off for ONE person, keeping every other
   * skill and expiry they hold. `expiresOn`: a YYYY-MM-DD sets it, null or ''
   * clears it, undefined keeps what is stored. Returns the new [{ id, expiresOn }].
   */
  function csSetHolder(currentSkills, skillId, on, expiresOn) {
    var mine = csPersonSkills({ skills: currentSkills });
    var id = csStr(skillId);
    if (!csIdOk(id)) return mine;
    var idx = -1;
    for (var i = 0; i < mine.length; i++) if (mine[i].id === id) idx = i;
    if (on !== true) {
      if (idx >= 0) mine.splice(idx, 1);
      return mine;
    }
    var exp = expiresOn === undefined ? (idx >= 0 ? mine[idx].expiresOn : null) : (csDateKey(expiresOn) || null);
    if (idx >= 0) { mine[idx] = { id: id, expiresOn: exp }; return mine; }
    if (mine.length >= CS_LIST_MAX) return mine;
    mine.push({ id: id, expiresOn: exp });
    return mine;
  }

  /**
   * PURE — apply one edit to a sanitised config. Returns { config } or { error }.
   * Never mutates the input.
   *   { kind:'enable', enabled }
   *   { kind:'add', label }                      → id generated ONCE
   *   { kind:'rename', id, label }               → label only, never the id
   *   { kind:'archive', id, archived }           → hidden from new picks + checks
   *   { kind:'require', scope:'jobType'|'vehicleType', key, ids }
   *   { kind:'toggleRequire', scope, key, id, on }  → one skill on/off for one type
   */
  function csApply(config, op) {
    var c = csConfig({ crewSkills: config });
    var next = { enabled: c.enabled, list: c.list.map(function (s) { return { id: s.id, label: s.label, archived: s.archived }; }), byJobType: {}, byVehicleType: {} };
    Object.keys(c.byJobType).forEach(function (k) { next.byJobType[k] = c.byJobType[k].slice(); });
    Object.keys(c.byVehicleType).forEach(function (k) { next.byVehicleType[k] = c.byVehicleType[k].slice(); });
    if (!op || typeof op !== 'object') return { error: 'Nothing to change.' };
    var same = function (a, b) { return csStr(a).toLowerCase() === csStr(b).toLowerCase(); };
    if (op.kind === 'enable') { next.enabled = op.enabled === true; return { config: next }; }
    if (op.kind === 'add') {
      var label = csCleanLabel(op.label);
      if (!label) return { error: 'Type a name for the skill.' };
      if (next.list.length >= CS_LIST_MAX) return { error: 'The list is full (' + CS_LIST_MAX + ' skills, archived ones included). Rename an archived skill and restore it instead.' };
      var dup = next.list.filter(function (s) { return same(s.label, label); })[0];
      if (dup) return { error: dup.archived ? '"' + dup.label + '" is archived — restore it instead.' : '"' + dup.label + '" is already on the list.' };
      var id = csMakeId(label, next.list.map(function (s) { return s.id; }));
      next.list.push({ id: id, label: label, archived: false });
      return { config: next, id: id };
    }
    var idx = -1;
    for (var i = 0; i < next.list.length; i++) if (next.list[i].id === op.id) idx = i;
    if (op.kind === 'rename') {
      if (idx < 0) return { error: 'That skill is no longer on the list.' };
      var nl = csCleanLabel(op.label);
      if (!nl) return { error: 'A skill needs a name.' };
      for (var d = 0; d < next.list.length; d++) if (d !== idx && same(next.list[d].label, nl)) return { error: '"' + next.list[d].label + '" is already on the list.' };
      next.list[idx].label = nl;
      return { config: next };
    }
    if (op.kind === 'archive') {
      if (idx < 0) return { error: 'That skill is no longer on the list.' };
      next.list[idx].archived = op.archived === true;
      return { config: next };
    }
    if (op.kind === 'require') {
      var map = op.scope === 'jobType' ? next.byJobType : op.scope === 'vehicleType' ? next.byVehicleType : null;
      var key = csStr(op.key);
      if (!map || !key || key.length > 80) return { error: 'Unknown type.' };
      var known = {};
      next.list.forEach(function (s) { known[s.id] = true; });
      var ids = csIdList(op.ids, known);
      if (ids.length) map[key] = ids; else delete map[key];
      return { config: next };
    }
    // One skill on/off for one type, applied to the CURRENT list (the Roster
    // modal sends this, never a whole set rebuilt from its DOM — COD r1: two
    // editors toggling different skills would otherwise erase each other).
    if (op.kind === 'toggleRequire') {
      var tmap = op.scope === 'jobType' ? next.byJobType : op.scope === 'vehicleType' ? next.byVehicleType : null;
      var tkey = csStr(op.key);
      if (!tmap || !tkey || tkey.length > 80) return { error: 'Unknown type.' };
      // M3 — a cert id ('cert:<itemId>') is not on the skills list; it can be
      // switched on or off by its shape (the screen offers active trainings only).
      if (idx < 0 && !csCertIdOk(op.id)) return { error: 'That skill is no longer on the list.' };
      var cur = (tmap[tkey] || []).filter(function (x) { return x !== op.id; });
      if (op.on === true) {
        if (cur.length >= CS_REQUIRED_MAX) return { error: 'A type can need at most ' + CS_REQUIRED_MAX + ' skills and certifications.' };
        cur.push(op.id);
      }
      if (cur.length) tmap[tkey] = cur; else delete tmap[tkey];
      return { config: next };
    }
    return { error: 'Unknown change.' };
  }

  window.CrewSkills = Object.freeze({
    LABEL_MAX: CS_LABEL_MAX,
    LIST_MAX: CS_LIST_MAX,
    REQUIRED_MAX: CS_REQUIRED_MAX,
    cleanLabel: csCleanLabel,
    dateKey: csDateKey,
    makeId: csMakeId,
    config: csConfig,
    isOn: csIsOn,
    hasSkills: csHasSkills,
    setHolder: csSetHolder,
    skillById: csSkillById,
    personSkills: csPersonSkills,
    cleanPersonSkills: csCleanPersonSkills,
    holds: csHolds,
    qualified: csQualified,
    required: csRequired,
    checkCrew: csCheckCrew,
    issueText: csIssueText,
    expiring: csExpiring,
    apply: csApply,
    certIdOk: csCertIdOk,
    certId: csCertId,
    certItemId: csCertItemId,
    certList: csCertList,
    certHolds: csCertHolds,
    hasCertRequirement: csHasCertRequirement
  });
})();
